import React from 'react';
import { useDroppable } from '@dnd-kit/core';
import { Lead } from '../../types';
import { LeadCard } from '../LeadCard/LeadCard';
import './KanbanColumn.css';

interface KanbanColumnProps {
  id: string;
  title: string;
  leads: Lead[];
  headerExtra?: React.ReactNode;
  columnClassName?: string;
  onConvert?: (leadId: string) => void;
  onLose?: (leadId: string) => void;
  onOpenLead?: (leadId: string) => void;
  onStartLeadIa?: (leadId: string) => void | Promise<void>;
  onAssumeHumanLeadIa?: (leadId: string) => void | Promise<void>;
  onStopLeadIa?: (leadId: string) => void | Promise<void>;
  aiOrchestrationEnabled?: boolean;
  iaOrchestrationPendingLeadId?: string | null;
}

export const KanbanColumn: React.FC<KanbanColumnProps> = ({ 
  id, 
  title, 
  leads,
  headerExtra,
  columnClassName,
  onConvert,
  onLose,
  onOpenLead,
  onStartLeadIa,
  onAssumeHumanLeadIa,
  onStopLeadIa,
  aiOrchestrationEnabled = false,
  iaOrchestrationPendingLeadId = null,
}) => {
  const { setNodeRef, isOver } = useDroppable({
    id,
    data: {
      type: 'status-column',
      status: id,
    },
  });

  return (
    <div
      ref={setNodeRef}
      className={`kanban-column ${columnClassName || ''} ${isOver ? 'drag-over' : ''}`}
    >
      <div className="kanban-column-header">
        <h3>{title}</h3>
        <span className="lead-count">{leads.length}</span>
      </div>
      {headerExtra ? <div className="kanban-column-header-extra">{headerExtra}</div> : null}
      <div className="kanban-column-content">
        {leads.map((lead) => (
          <LeadCard 
            key={lead.leadId} 
            lead={lead}
            onConvert={onConvert}
            onLose={onLose}
            onOpenLead={onOpenLead}
            onStartLeadIa={onStartLeadIa}
            onAssumeHumanLeadIa={onAssumeHumanLeadIa}
            onStopLeadIa={onStopLeadIa}
            aiOrchestrationEnabled={aiOrchestrationEnabled}
            iaStartPending={iaOrchestrationPendingLeadId === lead.leadId}
          />
        ))}
        {leads.length === 0 && (
          <div className="empty-column">Nenhum lead nesta coluna</div>
        )}
      </div>
    </div>
  );
};
